function isPrimitive(value) {
    switch (typeof value) {
        case 'bigint':
        case 'boolean':
        case 'function':
        case 'number':
        case 'string':
        case 'symbol':
        case 'undefined':
            return true;
        case 'object':
            return value === null;
        // Below should be impossible to get to
        /* istanbul ignore next */
        default:
            return false;
    }
}

export { isPrimitive };
